const areaReducer = (state = "", action) => {
    switch (action.type) {
        case "setArea":
            return action.payload;
        default:
            return state;
    }
};

export default areaReducer;
